<template>
  <v-card class="h-full">
    <ODialogBar title="Configuração da Medição" no-close>
      <v-spacer />
      <v-btn icon @click="() => $refs.dialog.open(row.id)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </ODialogBar>
    <v-card-text>
      <OCapCont label="Referência" class="mb-4">
        {{ strReferenceDay }}
      </OCapCont>
      <OCapCont label="Dia do Faturamento" class="mb-4">
        {{ row.invoiceDay }} (depois do período anterior)
      </OCapCont>
      <OCapCont label="Vencimento" class="mb-4">
        {{ strDue }}
      </OCapCont>
      <OCapCont label="Requer Aprovação de Medição" class="mb-4">
        {{ row.requiresMeasureApproval ? 'Sim' : 'Não' }}
      </OCapCont>
    </v-card-text>

    <OSimpleEditDialog
      ref="dialog"
      title="Editar Configuração da Medição"
      :fetchData="fetchData"
      :doSave="doSave"
      @reload="$emit('reload')"
      strings="config medição;a"
    >
      <template v-slot="{ row }">
        <v-form
          ref="theForm"
          class="d-flex flex-row flex-wrap pa-3 children-pa-3"
        >
          <OTextField
            class="w-1/2"
            label="Dia de Referência"
            v-model="row.referenceDay"
          />

          <OTextField
            class="w-1/2"
            label="Dia do Faturamento"
            v-model="row.invoiceDay"
          />

          <OTextField
            class="w-1/2"
            label="Dia do Vencimento"
            v-model="row.dueDay"
          />

          <OTextField
            class="w-1/2"
            label="Meses até o Vencimento"
            v-model="row.monthDelta"
          />

          <OSelect
            class="w-2/3"
            label="Requer Aprovação de Medição"
            v-model="row.requiresMeasureApproval"
            :items="measureApprovalOpts"
          />
        </v-form>
      </template>
    </OSimpleEditDialog>
  </v-card>
</template>

<script>
import OSimpleEditDialog from 'oderon-vue/cpts/dialogs/OSimpleEditDialog.vue'
import { CostCenter } from '@/models'

export default {
  components: { OSimpleEditDialog },
  props: {
    row: { required: true }
  },
  data() {
    return {
      measureApprovalOpts: [
        {
          value: false,
          text: 'Não ─ medição pode ser fechada e faturada em seguida'
        },
        {
          value: true,
          text:
            'Sim ─ medição precisa passar por aprovador antes de ser faturada'
        }
      ]
    }
  },
  computed: {
    strReferenceDay() {
      let d = this.row.referenceDay
      if (d == null) return '─'

      if (d == 1) return 'Do dia 1 até o último dia do mês, inclusive'

      return `Do dia ${d} de um mês até dia ${d - 1} do mês seguinte, inclusive`
    },
    strDue() {
      let d = this.row.dueDay
      if (d == null) return '─'

      let m = this.row.monthDelta
      if (m == null) m = 1

      return `Dia ${d} do mês +${m}`
    }
  },
  methods: {
    async fetchData(id) {
      return await CostCenter.findById(id)
    },
    async doSave(row) {
      return await CostCenter.save(row)
    }
  }
}
</script>

<style></style>
